"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTraitsMap = exports.allTraits = void 0;
exports.allTraits = [
    {
        id: "fire",
        name: "Fire",
        icon: "fire",
        tiers: [],
    },
    {
        id: "water",
        name: "Water",
        icon: "water",
        tiers: [],
    },
    {
        id: "earth",
        name: "Earth",
        icon: "earth",
        tiers: [],
    },
    {
        id: "wood",
        name: "Wood",
        icon: "wood",
        tiers: [],
    },
    {
        id: "metal",
        name: "Metal",
        icon: "metal",
        tiers: [],
    },
    {
        id: "arcane",
        name: "Arcane",
        icon: "arcane",
        tiers: [],
    },
    {
        id: "valiant",
        name: "Valiant",
        icon: "valiant",
        tiers: [],
    },
    {
        id: "cunning",
        name: "Cunning",
        icon: "cunning",
        tiers: [],
    },
];
exports.allTraitsMap = new Map(exports.allTraits.map((trait) => [trait.id, trait]));
